import { Box, Container, Flex, IconButton } from '@chakra-ui/react';
import { faClipboardListCheck, faGear, faHome } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/router';
import { FC, ReactNode } from 'react';
import Link from 'src/components/common/link/Link';
import { FLAGS, useFeatureFlag } from 'src/utils/hooks/useFeatureFlag';
import { faMessageWaveform } from 'src/utils/icons/faMessageWaveform';

type Props = {
    actionComponent?: ReactNode;
};

const Bottombar: FC<Props> = (props) => {
    const { actionComponent } = props;
    const router = useRouter();
    const assistantEnabled = useFeatureFlag(FLAGS.voiceCapture);

    // The assistant IS the dashboard once the flag is on: same slot, same job —
    // what the day still owes — now answered conversationally. The flag swaps
    // the two, so turning it off restores the old screen untouched.
    const daily = assistantEnabled
        ? { href: '/assistant', 'aria-label': 'assistant', faIcon: faMessageWaveform }
        : { href: '/dashboard', 'aria-label': 'dashboard', faIcon: faClipboardListCheck };

    const buttons = [
        { href: '/home', 'aria-label': 'home', faIcon: faHome },
        daily,
        { href: '/settings', 'aria-label': 'settings', faIcon: faGear }
    ].map((button) => ({
        ...button,
        icon: (
            <FontAwesomeIcon
                color={router.asPath.endsWith(button.href) ? 'lime.500' : undefined}
                icon={button.faIcon}
                size="lg"
            />
        )
    }));

    return (
        <>
            {actionComponent && actionComponent}
            <Box
                aria-label="bottombar"
                bg="white"
                bottom={0}
                paddingY={2}
                position="fixed"
                width="100%"
                zIndex="banner"
            >
                <Container maxW="container.sm">
                    <Flex
                        bg="white"
                        borderRadius="0.9375rem"
                        boxShadow="0px 0px 50px rgba(90, 108, 234, 0.1)"
                        justifyContent="space-around"
                    >
                        {buttons.map((button) => (
                            <Link key={button.href} passHref href={button.href}>
                                <IconButton
                                    aria-label={button['aria-label']}
                                    icon={button.icon}
                                    size="lg"
                                    variant={
                                        router.asPath.endsWith(button.href)
                                            ? 'limeClear'
                                            : 'blackClear'
                                    }
                                />
                            </Link>
                        ))}
                    </Flex>
                </Container>
            </Box>
        </>
    );
};

export default Bottombar;
